import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "index",
    redirect: "myself",
    component: () => import("@/views/report/index.vue"),
    children: [
      {
        path: "myself",
        name: "myself",
        component: () => import("@/views/report/myself.vue"),
        children: []
      },
      {
        path: "day",
        name: "day",
        component: () => import("@/views/report/day.vue")
      },
      {
        path: "dayList",
        name: "dayList",
        component: () => import("@/views/report/dayList.vue")
      },
      {
        path: "dayDetail",
        name: "dayDetail",
        component: () => import("@/views/report/dayDetail.vue")
      }
    ]
  },
  {
    path: "/rkStatistics",
    name: "rkStatistics",
    redirect: "/rkStatistics/chart",
    component: () => import("@/components/rkStatistics/index.vue"),
    children: [
      {
        path: "/rkStatistics/list",
        name: "rkStatisticsList",
        component: () => import("@/components/rkStatistics/list.vue")
      },
      {
        path: "/rkStatistics/chart",
        name: "rkStatisticsChart",
        component: () => import("@/components/rkStatistics/chart.vue")
      },
      {
        path: "/rkStatistics/detail",
        name: "rkStatisticsDetail",
        component: () => import("@/components/rkStatistics/detail.vue")
      }
    ]
  },
  {
    path: "/skStatistics",
    name: "skStatistics",
    redirect: "/skStatistics/chart",
    component: () => import("@/components/skStatistics/index.vue"),
    children: [
      {
        path: "/skStatistics/list",
        name: "skStatisticsList",
        component: () => import("@/components/skStatistics/list.vue")
      },
      {
        path: "/skStatistics/chart",
        name: "skStatisticsChart",
        component: () => import("@/components/skStatistics/chart.vue")
      },
      {
        path: "/skStatistics/detail",
        name: "skStatisticsDetail",
        component: () => import("@/components/skStatistics/detail.vue")
      }
    ]
  },
  {
    path: "/kcStatistics",
    name: "kcStatistics",
    redirect: "/kcStatistics/chart",
    component: () => import("@/components/kcStatistics/index.vue"),
    children: [
      {
        path: "/kcStatistics/list",
        name: "kcStatisticsList",
        component: () => import("@/components/kcStatistics/list.vue")
      },
      {
        path: "/kcStatistics/chart",
        name: "kcStatisticsChart",
        component: () => import("@/components/kcStatistics/chart.vue")
      },
      {
        path: "/kcStatistics/detail",
        name: "kcStatisticsDetail",
        component: () => import("@/components/kcStatistics/detail.vue")
      }
    ]
  },
  {
    path: "/loginAnalyse",
    name: "loginAnalyse",
    redirect: "/loginAnalyse/chart",
    component: () => import("@/views/loginAnalyse/index.vue"),
    children: [
      {
        path: "/loginAnalyse/indexList",
        name: "indexList",
        component: () => import("@/views/loginAnalyse/indexList.vue")
      },
      {
        path: "/loginAnalyse/chart",
        name: "chart",
        component: () => import("@/views/loginAnalyse/chart.vue")
      }
    ]
  },
  {
    path: "/platformStatements",
    name: "platformStatements",
    redirect: "/platformStatements/statements",
    component: () => import("@/views/platformStatements/index.vue"),
    children: [
      {
        path: "/platformStatements/detail",
        name: "detail",
        component: () => import("@/views/platformStatements/detail.vue")
      },
      {
        path: "/platformStatements/list",
        name: "list",
        component: () => import("@/views/platformStatements/list.vue")
      },
      {
        path: "/platformStatements/statements",
        name: "statements",
        component: () => import("@/views/platformStatements/indexList.vue")
      }
    ]
  },
  {
    path: "/views",
    name: "views",
    redirect: "/views/chart",
    component: () => import("@/views/views/index.vue"),
    children: [
      {
        path: "/views/chart",
        name: "chart",
        component: () => import("@/views/views/chart.vue")
      },
      {
        path: "/views/indexList",
        name: "indexList",
        component: () => import("@/views/views/indexList.vue")
      },
      {
        path: "/views/detail",
        name: "detail",
        component: () => import("@/views/views/detail.vue")
      }
    ]
  },
  {
    path: "/loginManage",
    name: "loginManage",
    redirect: "/loginManage/list",
    component: () => import("@/views/loginManage/index.vue"),
    children: [
      {
        path: "/loginManage/list",
        name: "list",
        component: () => import("@/views/loginManage/list.vue")
      },
      {
        path: "/loginManage/setList",
        name: "setList",
        component: () => import("@/views/loginManage/setList.vue")
      }
    ]
  },
  {
    path: "/productInfo",
    name: "productInfo",
    redirect: "/productInfo/indexList",
    component: () => import("@/views/productInfo/index.vue"),
    children: [
      {
        path: "/productInfo/indexList",
        name: "indexList",
        component: () => import("@/views/productInfo/indexList.vue")
      },
      {
        path: "/productInfo/create",
        name: "create",
        component: () => import("@/views/productInfo/create.vue")
      }
    ]
  },
  {
    path: "/dockPlatform",
    name: "dockPlatform",
    redirect: "/dockPlatform/indexList",
    component: () => import("@/views/dockPlatform/index.vue"),
    children: [
      {
        path: "/dockPlatform/indexList",
        name: "dockPlatform",
        component: () => import("@/views/dockPlatform/indexList.vue")
      },
      {
        path: "/dockPlatform/filialeList",
        name: "filialeList",
        component: () => import("@/views/dockPlatform/filialeList.vue")
      },
      {
        path: "/dockPlatform/confirmForm",
        name: "confirmForm",
        component: () => import("@/views/dockPlatform/confirmForm.vue")
      }
    ]
  },
  {
    path: "/pay",
    name: "pay",
    component: () => import("@/views/pay/index.vue")
  },
  // 订单页
  {
    path: "/h5order",
    name: "h5order",
    component: () => import("@/views/h5order/index.vue")
  },
  ,
  // 扫码续费
  {
    path: "/comPay",
    name: "comPay",
    component: () => import("@/views/pay/comPay.vue")
  },
  {
    path: "/ePay",
    name: "ePay",
    component: () => import("@/views/pay/epcPay.vue")
  },
  {
    path: "/yxwarn",
    name: "yxwarn",
    component: () => import("@/views/pay/yxwarn.vue")
  },
  {
    path: "/cancelPay",
    name: "cancelPay",
    component: () => import("@/views/cancelPay/index.vue")
  },
  // 申请
  {
    path: "/apply",
    name: "apply",
    redirect: "/apply/registered",
    component: () => import("@/components/apply/index.vue"),
    children: [
      {
        path: "/apply/registered",
        name: "registered",
        component: () => import("@/components/apply/registered.vue")
      },
      {
        path: "/apply/succeed",
        name: "succeed",
        component: () => import("@/components/apply/succeed.vue")
      }
    ]
  },
  // 审核
  {
    path: "/Audit",
    name: "Audit",
    component: () => import("@/components/Audit/index.vue")
  },
  // 提醒
  {
    path: "/remind",
    name: "remind",
    component: () => import("@/components/remind/index.vue")
  },
  {
    path: "/confirmForm",
    name: "confirmForm",
    component: () => import("@/views/dockPlatform/confirmForm.vue")
  },
  {
    path: "/filialeList",
    name: "filialeList",
    component: () => import("@/views/dockPlatform/filialeList.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/components/login")
  },
  {
    path: "/confirm",
    name: "confirm",
    component: () => import("@/components/confirm")
  },
  {
    path: "/wxLogin",
    name: "wxLogin",
    component: () => import("@/components/wxLogin.vue")
  },
  {
    path: "/authorize",
    name: "authorize",
    component: () => import("@/components/authorize.vue")
  },
  {
    path: "/viewer",
    name: "viewer",
    component: () => import("@/components/viewer.vue")
  },
  {
    path: "/invoice",
    name: "invoice",
    component: () => import("@/components/invoice.vue")
  },
  {
    path: "/wxBind",
    name: "wxBind",
    component: () => import("@/components/wxBind.vue")
  },
  {
    path: "/loginApply",
    name: "loginApply",
    component: () => import("@/components/loginApply")
  },
  {
    path: "/finish",
    name: "finish",
    component: () => import("@/components/finish")
  },
  {
    path: "/setTargetAmount",
    name: "setTargetAmount",
    component: () => import("@/components/setTargetAmount.vue")
  },
  {
    path: "/down",
    name: "down",
    component: () => import("@/components/down.vue")
  },
  {
    path: "/wxInvokeScan",
    name: "wxInvokeScan",
    component: () => import("@/components/wxInvokeScan.vue")
  }
];

const router = new Router({
  routes,
  mode: "history"
});
/** 导航守卫 */
router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    next();
  } else {
    // let token = localStorage.getItem('Authorization')

    // if (token === null || token === '') {
    //   this.common.returnWXAuthorization()
    // } else {
    next();
    // }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js